import { render, staticRenderFns } from "./ProjectGridRow.vue?vue&type=template&id=f8aae9fc&scoped=true&"
import script from "./ProjectGridRow.vue?vue&type=script&lang=js&"
export * from "./ProjectGridRow.vue?vue&type=script&lang=js&"
import style0 from "./ProjectGridRow.vue?vue&type=style&index=0&id=f8aae9fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8aae9fc",
  null
  
)

export default component.exports